module.exports = __webpack_public_path__ + "static/media/right-arrow-icon--main-color.c221b35a.svg";